import { FC, useState, MouseEvent } from 'react';
import { Badge, BottomNavigationAction, IconButton } from '@mui/material';

import NotificationIcon from 'components/common/icons/bulk/Notification';
import useMount from 'hooks/useMount';
import useNotifications from 'store/notifications';
import { translate } from 'utils/translate';

import NotificationMenu from './NotificationMenu';

type Props = {
  footerAnchor?: null | HTMLElement;
};

const Notifications: FC<Props> = ({ footerAnchor }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [notificationsState, notificationsActions] = useNotifications();

  const isNotificationOpen = Boolean(anchorEl);

  const handleNotificationClick = (event: MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(footerAnchor || event.currentTarget);
  };
  const handleNotificationClose = (): void => {
    setAnchorEl(null);
  };

  useMount(() => {
    notificationsActions.getUnreadCount();
  });

  const needToWrapIcon = !!footerAnchor;

  const unreadCount = typeof notificationsState.unreadCount === 'number' ? notificationsState.unreadCount : 0;

  const IconWithBadge =
    unreadCount > 0 ? (
      <Badge color="error" badgeContent={unreadCount} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <NotificationIcon />
      </Badge>
    ) : (
      <NotificationIcon />
    );

  const Icon = needToWrapIcon ? (
    <BottomNavigationAction showLabel label={translate('Notifications')} icon={IconWithBadge} />
  ) : (
    IconWithBadge
  );
  return (
    <>
      <IconButton onClick={handleNotificationClick}>{Icon}</IconButton>
      {isNotificationOpen && <NotificationMenu anchorEl={anchorEl} onClose={handleNotificationClose} />}
    </>
  );
};

export default Notifications;
